import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logoImage from '@/assets/images/logo/sort_1_logo_black.png';
import { LoginForm } from '@/components/pages/login/LoginForm';
import ErrorDialog from '@/components/shared/errorDialog';
import { MobiTitle } from '@/components/shared/MobiTitle';
import { MAINTENANCE_ERROR_MESSAGE } from '@/constants/constants';

export const Login = () => {
  const { t } = useTranslation();
  const [errorOpen, setErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const loginPageHeight = 556;

  // メンテナンスエラーメッセージの確認
  useEffect(() => {
    const maintenanceErrorMsg = sessionStorage.getItem(MAINTENANCE_ERROR_MESSAGE);
    if (maintenanceErrorMsg) {
      setErrorMessage(maintenanceErrorMsg);
      setErrorOpen(true);
    }
  }, []);

  return (
    <div className="login-page">
      <div className="login-screen-shell">
        <MobiTitle>{t('header.login')}</MobiTitle>

        <div className="login-content-stack" style={{ minHeight: `${loginPageHeight}px` }}>
          <div className="login-header-block">
            <div className="login-brand-block">
              <img className="login-brand-logo-image" src={logoImage} alt="mobi logo" />
            </div>

            <h1 className="login-screen-heading">{t('header.login')}</h1>
          </div>

          <div className="login-form-panel">
            <LoginForm />
          </div>
        </div>

        {errorOpen && (
          <ErrorDialog
            open={errorOpen}
            errorMessage={errorMessage}
            onClose={(flag) => {
              setErrorOpen(flag);
              sessionStorage.removeItem(MAINTENANCE_ERROR_MESSAGE);
            }}
          />
        )}
      </div>
    </div>
  );
};
